function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2455 9.70457C15.7582 10.1918 14.9682 10.1918 14.481 9.70457L8.30536 3.52894C7.33087 2.55445 7.33087 0.974496 8.30536 7.62939e-06L16.2455 7.94011C16.7327 8.42735 16.7327 9.21733 16.2455 9.70457Z",
  fill: "#708390"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.365431 9.70446C-0.121813 9.21721 -0.121813 8.42724 0.365431 7.93999L8.30536 7.62939e-06C9.27985 0.974496 9.27985 2.55445 8.30536 3.52894L2.1299 9.70446C1.64265 10.1917 0.852675 10.1917 0.365431 9.70446Z",
  fill: "#708390"
});

var SvgNavUpIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavUpIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nav-up-icon.6456fc84.svg";
export { ForwardRef as ReactComponent };